export const appSettingsKey = 'RESTAVO_APP_SETTINGS';

const appSettings = JSON.parse(localStorage.getItem(appSettingsKey) || JSON.stringify({}));

export const theme = appSettings?.state?.theme;
export const locale = appSettings?.state?.locale || import.meta.env.VITE_DEFAULT_LOCALE || 'vi';
